function getPrice (parking) {
    const { bookingAvailability, estimatedBookingPrice } = parking

    if (parking.isActive) {
        return { ...bookingAvailability.price_qty }
    }

    if (parking.isUnavailableDueToRelease) {
        return { ...estimatedBookingPrice.price }
    }

    return null
}

export default getPrice
